import { useState } from 'react'
import { useTheme } from '../ThemeContext'
import { affiliateData, company } from '../data/AffiliateData'

export default function ExportModal({ leadStageId, setShowExport }) {
  const { isDarkMode } = useTheme()
  const [sortOption, setSortOption] = useState('Modified')
  const [exportingData, setExportingData] = useState(false)
  const [exportedData, setExportedData] = useState(false)

  const handleStartExport = async () => {
    setExportingData(true)

    const startExportResponse = await fetch('https://myportal.setcpros.com/cronjobs/api/startExport', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        companyId: company.companyId,
        affiliateId: affiliateData.account.accountId,
        leadStageId: leadStageId,
        sortBy: sortOption,
        email: affiliateData.account.accountEmail
      })
    })
    const startExportData = await startExportResponse.json()
    setExportingData(false)

    if(startExportData.response.error)
      console.error(startExportData.response.error)
    else
      setExportedData(true)
  }

  return (
    <div className='fixed inset-0 flex justify-center items-center z-50 font-mont'>
      <div className='fixed inset-0 bg-gray-800 bg-opacity-75 backdrop-blur-sm'></div>
      <div className={`relative p-8 rounded-xl shadow-xl max-w-2xl w-full mx-4 sm:mx-auto overflow-y-auto transition-transform transform scale-95 ${isDarkMode ? 'bg-gray-900' : 'bg-white'}`}>
        <div className='w-full flex flex-col items-center'>
          <div className='relative w-full flex flex-row justify-center items-center'>
            <p className={`${isDarkMode && 'text-white'} font-bold text-3xl mb-4`}>Export Data</p>
            <button onClick={() => { setExportedData(false); setShowExport(false) }} className='absolute text-red-700 hover:text-red-900 transition-colors duration-200 mb-10 right-0'>
              <svg xmlns='http://www.w3.org/2000/svg' className='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M6 18L18 6M6 6l12 12' />
              </svg>
            </button>
          </div>
          {!exportedData ? (
            <div className='w-full flex flex-col items-center gap-4'>
              <p className={`${isDarkMode && 'text-white'}`}>Please select how you want the data to be sorted.</p>
              <div className='w-full mb-4'>
                <label className={`${isDarkMode ? 'text-white' : 'text-gray-700'} block text-sm font-medium mb-2`}>
                  Sort by:
                </label>
                <select 
                  value={sortOption} 
                  onChange={(e) => setSortOption(e.target.value)} 
                  className={`w-full border rounded-lg px-4 py-2 shadow-sm transition-colors duration-200 ${isDarkMode ? 'bg-gray-700 text-white border-gray-600' : 'bg-white text-gray-900 border-gray-300'}`}
                >
                  <option value='Name'>Name</option>
                  <option value='Amount'>Amount</option>
                  <option value='Modified'>Modified</option>
                  <option value='Created'>Created</option>
                </select>
              </div>
              <button
                disabled={exportingData}
                onClick={handleStartExport} 
                className={`mt-4 px-6 py-2 text-white rounded-md transition-colors ${exportingData ? 'bg-gray-400 cursor-not-allowed' : 'bg-primaryColor hover:bg-primaryDarkColor'}`}
              >
                Start Export
              </button>
            </div>
          ) : (
            <div className='w-full flex flex-col gap-4 items-center'>
              <p className={`${isDarkMode && 'text-white'}`}>Data exporting has started. Please allow time for data to compile. You will receive an email once completed.</p>
              <button
                onClick={() => { setExportedData(false); setShowExport(false) }} 
                className='mt-4 px-6 py-2 text-white rounded-md transition-colors bg-primaryColor hover:bg-primaryDarkColor'
              >
                Ok
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
